import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PanelSection from './PanelSection';

type View3DSectionProps = {
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  maxHeightClassName?: string;
};

/**
 * Collapsible 3D controls block in the property panel (floor distance, tilt, etc.).
 */
const View3DSection: React.FC<View3DSectionProps> = ({
  children,
  defaultOpen = true,
  className = 'p-3',
  maxHeightClassName = 'max-h-none',
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <PanelSection
      title={t('propertyPanel.view3D')}
      collapsible
      open={open}
      onToggle={() => setOpen(!open)}
      maxHeightClassName={maxHeightClassName}
      className={className}
    >
      <div className="space-y-0.5 px-3 pb-1 pt-0">{children}</div>
    </PanelSection>
  );
};

export default View3DSection;
